import { useCallback, useEffect, useMemo, useState } from 'react';
import { createBridgeAgentMcpApi } from './bridgeAgentMcpApi';

export function useAgentMcpStatus({ enabled, bridgeClient, api: injectedApi = null }) {
  const api = useMemo(
    () => injectedApi || createBridgeAgentMcpApi({ client: bridgeClient }),
    [bridgeClient, injectedApi],
  );
  const [state, setState] = useState(null);
  const [isLoading, setIsLoading] = useState(enabled);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  const reload = useCallback(() => setReloadKey(value => value + 1), []);

  useEffect(() => {
    if (!enabled) {
      setState(null);
      setError(null);
      setIsLoading(false);
      return undefined;
    }

    let cancelled = false;
    setIsLoading(true);
    setError(null);
    api.getStatus()
      .then((next) => {
        if (!cancelled) setState(next);
      })
      .catch((nextError) => {
        if (!cancelled) setError(nextError);
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => { cancelled = true; };
  }, [api, enabled, reloadKey]);

  return {
    api,
    state,
    setState,
    isLoading,
    error,
    setError,
    reload,
  };
}
